import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const preview = faqs.slice(0, 4);

  return (
    <section className="w-full bg-background-100 py-16 md:py-24" aria-labelledby="home-faq">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <SectionHeading
                id="home-faq"
                eyebrow="常见问题"
                title="关于提供线索，你可能会问"
                description="我们把最常见的问题整理在这里，若仍有疑问，可前往常见问题页面查看完整说明。"
              />
            </Reveal>
            <Reveal delay={100}>
              <Link
                to="/faq"
                className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                查看全部问题
                <i className="ri-arrow-right-line" />
              </Link>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={80}>
              <FaqAccordion items={preview} defaultOpenId={preview[0]?.id} />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}